<ng-container *ngIf="readonly; else currencyInput">
  {{
    this.bindingFormControl?.value
      | number : currencySetting!.format
      | replaceNullWith : '-'
  }}
  <ng-container *ngIf="showCurrency">
    {{ currencySetting?.currency }}
  </ng-container>
</ng-container>
<ng-template #currencyInput>
  <div class="layout-box" style="display: flex">
    <sigv-form-control-widget
      [bindingFormControl]="bindingFormControl"
      [style]="inputWidth"
    >
      <p-inputNumber
        [maxFractionDigits]="digitInfo?.maxFraction"
        [minFractionDigits]="digitInfo?.minFraction"
        [maxlength]="digitInfo?.maxInt"
        [disabled]="disabled"
        [formControl]="bindingFormControl"
        [inputStyle]="isInputRight ? { 'text-align': 'right' } : {}"
        (ngModelChange)="onModelChange($event)"
        (onFocus)="focused.emit($event)"
        (onBlur)="blured.emit($event)"
        (onInput)="inputed.emit($event)"
      ></p-inputNumber>
    </sigv-form-control-widget>
    <ng-container *ngIf="showCurrency">
      <span class="currency-sign" [style]="currencySignPosition">{{
        currencySetting?.currency
      }}</span>
    </ng-container>
  </div>
</ng-template>
